import { render, staticRenderFns } from "./platformCommission.vue?vue&type=template&id=36d29989&scoped=true"
import script from "./platformCommission.vue?vue&type=script&lang=js"
export * from "./platformCommission.vue?vue&type=script&lang=js"
import style0 from "./platformCommission.vue?vue&type=style&index=0&id=36d29989&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d29989",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36d29989')) {
      api.createRecord('36d29989', component.options)
    } else {
      api.reload('36d29989', component.options)
    }
    module.hot.accept("./platformCommission.vue?vue&type=template&id=36d29989&scoped=true", function () {
      api.rerender('36d29989', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/financeManagement/platformCommission/platformCommission.vue"
export default component.exports